import { render, staticRenderFns } from "./listMultiShare.vue?vue&type=template&id=5bb25b72"
import script from "./listMultiShare.vue?vue&type=script&lang=js"
export * from "./listMultiShare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports